<template>

    <div>
        <v-tooltip top color="primary" nudge-bottom="100" :open-delay="400" :close-delay="400" v-if="editMode">
            <template v-slot:activator="{ on }">
                <v-scale-transition>
                    <v-card v-on="on" flat tile color="transparent" v-show="visible">

                        <v-img v-if="logo"
                               contain
                               :aspect-ratio="3/1"
                               :max-width="570"
                               :src="logo"/>
                    </v-card>
                </v-scale-transition>
            </template>
            <span>This logo can be changed in sub panel settings</span>
        </v-tooltip>

        <div v-else>
            <v-img v-if="logo"
                   contain
                   :aspect-ratio="3/1"
                   :max-width="570"
                   :src="logo"/>
        </div>
    </div>

</template>

<script>
export default {

    props: {
        logoUrl: {
            required: true,
            type: String | null,
        },
        visible: {
            type: Boolean,
            required: false,
            default: true,
        },
        editMode: {
            type: Boolean,
            required: false,
            default: true,
        }
    },

    computed: {
        logo() {
            return this.logoUrl ? this.logoUrl : null;
        }
    }
}
</script>
